// RealtimeInitializer.jsx
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { init } from '../action/realtimeActions.js';

export const RealtimeInitializer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(init());
  }, [dispatch]);

  return null;
};

export default RealtimeInitializer;
